import React from 'react';
import { Icon } from './Icon.js';
export const IconRectLayoutGrid5Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M7,8.25h10v-3.5c0-1.517-1.233-2.75-2.75-2.75H7v6.25Z", fill: "currentColor" }),
        React.createElement("rect", { x: "7", y: "9.75", width: "4", height: "6.25", fill: "currentColor" }),
        React.createElement("path", { d: "M12.5,9.75v6.25h1.75c1.517,0,2.75-1.233,2.75-2.75v-3.5h-4.5Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M5.5,2h-1.75c-1.517,0-2.75,1.233-2.75,2.75V13.25c0,1.517,1.233,2.75,2.75,2.75h1.75V2Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconRectLayoutGrid5Fill18.js.map